import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88518eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("完成合同")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_ctx.type === 'list')
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "javascript:void(0);",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.completeContract()))
      }, "完成合同"))
    : (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.completeContract()))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }))
}